import { z } from 'zod';
import { CAL_EVENT_PHOTO_MAX_BYTES } from '../../events/cal-event-photo-max-bytes.js';
import { CAL_EVENT_PHOTO_NOTE_MAX_LENGTH } from '../../events/cal-event-photo-note-max-length.js';
import { estimatedDecodedByteLength, normalizeUploadBase64, } from '../purchase-order/upload-file-input.js';
import { optionalClientGeneratedUuidString } from '../zod-helpers/optional-client-generated-uuid-string.js';
export const uploadCalEventPhotoInputSchema = z
    .object({
    fileName: z
        .string()
        .trim()
        .min(1, 'File name is required.')
        .max(255)
        .regex(/^[\x20-\x7E\x80-\xFF]+$/, 'File name contains unsupported characters.'),
    note: z
        .string()
        .max(CAL_EVENT_PHOTO_NOTE_MAX_LENGTH, `Note must be ${CAL_EVENT_PHOTO_NOTE_MAX_LENGTH} characters or fewer.`)
        .nullish(),
    clientUploadId: optionalClientGeneratedUuidString('Invalid upload id.'),
    contentBase64: z
        .string()
        .min(1, 'Photo content is required.')
        .max(Math.ceil((CAL_EVENT_PHOTO_MAX_BYTES * 4) / 3) + 100, 'Photo exceeds the maximum allowed size.'),
})
    .superRefine((value, ctx) => {
    const normalized = normalizeUploadBase64(value.contentBase64);
    if (!normalized) {
        ctx.addIssue({
            code: 'custom',
            message: 'Photo content is invalid.',
            path: ['contentBase64'],
        });
        return;
    }
    const byteLength = estimatedDecodedByteLength(normalized);
    if (byteLength === 0) {
        ctx.addIssue({ code: 'custom', message: 'Photo is empty.', path: ['contentBase64'] });
    }
    else if (byteLength > CAL_EVENT_PHOTO_MAX_BYTES) {
        ctx.addIssue({
            code: 'custom',
            message: `Photo must be ${CAL_EVENT_PHOTO_MAX_BYTES} bytes or smaller.`,
            path: ['contentBase64'],
        });
    }
});
//# sourceMappingURL=upload-cal-event-photo-input.js.map